<template>
  <div class="downloadHistory">
    <slot-table :data="tableData" :columns="table.columns">
      <template slot="dateCreated" slot-scope="props">
          <span>
            {{ props.item.date_created.value }}
          </span>
      </template>

      <template slot="requestedBy" slot-scope="props">
          <span>
           <a v-bind:href="'mailto:' + props.item.username + '?subject=Otomo Download query'" target="_blank">{{ props.item.name }}</a>
          </span>
      </template>

      <template slot="progress" slot-scope="props">
        <progress-bar :value="props.item.progress" :status="props.item.status.replace('_', ' ').toLowerCase()" />
      </template>

      <template slot="status" slot-scope="props">
          <span :class="statusCss(props.item.status)">
            {{ props.item.status.replace('_', ' ') }}
          </span>
      </template>

      <template slot="actions" slot-scope="props">
        <span>
            <button v-if="props.item.progress === 100 && props.item.status === 'success' " @click="downloadFile(props.item.url)" class="btn btn-xs btn-primary"><i class="fa fa-download"></i> Download</button>
            <p v-else>-</p>
        </span>
      </template>
    </slot-table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {downloadMixin} from '@/mixins/downloadMixin'
import { MEDIA_URL } from '@/config'

export default {
  name: 'DownloadTable',
  mixins: [downloadMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    ProgressBar,
    SwitchButton,
    Checkbox,
    Heading
  },
  props: {
    tableData: Array
  },
  data: () => ({
    table: {
      columns: {
        requestedBy: 'Requested By',
        dateCreated: 'Date Created',
        status: 'Status',
        progress: 'Progress',
        actions: 'Actions'
      },
      statusKeys: {
        success: 'success',
        error: 'danger',
        in_progress: 'info',
        created: 'warning'
      }
    }
  }),
  methods: {
    downloadFile (file) {
      window.open(`${MEDIA_URL}${file}`, '_blank').focus()
    },
    statusCss (status) {
      let labelType = 'default'
      if (status !== 'new') {
        labelType = this.table.statusKeys[status]
      }
      return `label label-${labelType} text-center text-capitalize`
    }
  }
}
</script>

<style lang="scss">
    .asset__img, .asset__video {
      background-color: #ccc;
      background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
      background-size: 10px 10px;
      background-position: 0 0, 5px 5px;
      padding: 0px;
      max-width: 200px;
      max-height: 200px;
      img, video {
        object-fit: scale-down;
        border:2px solid #2c3247;
      }
      & #imageCover {
        z-index:50;
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(123,123,123,0);
      }
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .asset__video {
      background-color: black;
      max-width: 320px;
      max-height: 320px;
    }
    .top-buffer {
      margin-top:10px;
    }

    .progress-percentage {
      display: flex;
      align-content: center;
    }

    .loader-hidden {
      display: inline-block;
      width: 15px;
      height: 15px;
    }

    .loader {
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-right: 2px;
      background-color: #333;

      border-radius: 100%;
      -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
      animation: sk-scaleout 1.0s infinite ease-in-out;
    }

    @-webkit-keyframes sk-scaleout {
      0% { -webkit-transform: scale(0) }
      100% {
        -webkit-transform: scale(1.0);
        opacity: 0;
      }
    }

    @keyframes sk-scaleout {
      0% {
        -webkit-transform: scale(0);
        transform: scale(0);
      } 100% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
        opacity: 0;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/DownloadTable/download-table.vue